import { NavLink, Outlet, useParams } from "react-router"
import "./layout.css"

interface ServerTab {
  to: string
  label: string
  end?: boolean
}

const TABS: ServerTab[] = [
  { to: "", label: "Overview", end: true },
  { to: "console", label: "Consola" },
  { to: "logs", label: "Logs" },
  { to: "files", label: "Archivos" },
  { to: "mods", label: "Mods" },
  { to: "config", label: "Configuración" },
  { to: "backups", label: "Backups" },
  { to: "players", label: "Jugadores" },
  { to: "settings", label: "Ajustes" },
  { to: "access", label: "Acceso" },
]

/**
 * FR section 16, "Nivel de servidor". FR es explicito en que las tabs
 * "solo muestran las secciones a las que el usuario tiene permiso" (ej.
 * sin console.read no aparece Consola). No implementado todavia: el
 * Gateway no expone un endpoint REST de "que permisos tengo en este
 * servidor" para que el frontend filtre contra el (actorHasPermission()
 * solo existe server-side, en @mc/db / middleware del Gateway). Todas las
 * tabs se muestran sin filtrar por ahora — flag explicito en AGENT.md en
 * vez de improvisar un endpoint nuevo sin que el Architect lo revise.
 */
export function ServerTabsLayout() {
  const { serverId } = useParams()

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "var(--space-4)" }}>
      <nav className="mc-server-tabs" aria-label="Secciones del servidor">
        {TABS.map((tab) => (
          <NavLink
            key={tab.label}
            to={`/servers/${serverId}${tab.to ? `/${tab.to}` : ""}`}
            end={tab.end}
            className="mc-server-tab"
          >
            {tab.label}
          </NavLink>
        ))}
      </nav>
      <Outlet />
    </div>
  )
}
